import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class courierDp {
	static classname = 'courier-dp';

	_is_zones_instance_init = false;

	constructor($context) {
		this.$context = $context;

		this.bindGlobalEvents();
		this.bindObserver();
	}

	get id() {
		return this.$context.data('id');
	}

	get ZonesInstance() {
		if (window.shop_dp && window.shop_dp.loader && window.shop_dp.loader.assets) {
			const { shop_dp: { loader: { assets } } } = window;

			let services = {};
			if (assets.page && assets.page.services) {
				services = assets.page.services;
			} else if(assets.product && assets.product.services) {
				services = assets.product.services;
			}

			if (services[this.id]) {
				return services[this.id];
			}
		}

		return null;
	}

	bindGlobalEvents() {
		$(document).on('shop-dp-zones-inited', this.handleZonesInstanceInit);

		$(window).on('resize', this.handleWindowResize);
	}

	bindObserver() {
		this.observer = new MutationObserver(this.handleMutations);

		this.observer.observe(this.$context.find('.js-dp-service-search-wrapper')[0], {
			childList: true,
			subtree: true
		});
	}

	prepareBalloonPanel() {
		if (this.ZonesInstance) {
			this.ZonesInstance.map.map.options.set('balloonPanelMaxHeightRatio', 1);
			this.ZonesInstance.map.map.options.set('balloonPanelMaxMapArea', ResponsiveUtil.isToTablet() ? Infinity : 0);
		}
	}

	handleCreatedSuggestView = $suggest_view => {
		$suggest_view.addClass('courier-dp__suggest-items');

		const $items = $suggest_view.find('[class*="-suggest-item"]');
		$items.each(function () {
			const $item = $(this);
			$item.addClass('courier-dp__suggest-item');
			$item.find('[class*="search__suggest-item"]').addClass('courier-dp__suggest-item-inner');
		});

		$suggest_view.closest('[class*="search__suggest"]').addClass('courier-dp__suggest');
	};

	handleMutations = mutations => {
		mutations.forEach(mutation => {
			if(mutation.addedNodes.length) {
				const first_node = mutation.addedNodes[0];
				const $first_node = $(first_node);
				if ($first_node.is('[class*="suggest-item"]')) {
					this.handleCreatedSuggestView($(mutation.target));
				}
			}
		});
	};

	handleZonesInstanceInit = () => {
		this._is_zones_instance_init = true;

		this.prepareBalloonPanel();
	};

	handleWindowResize = () => {
		this.prepareBalloonPanel();
	};
}
